window.skReturnUserMedia = image => {
  const event = new CustomEvent('photoReceived', { detail: image });
  window.dispatchEvent(event)
}

window.skCancelledUserMedia = () => {
  const event = new CustomEvent('errorModal', {
    detail: {
      title: 'Cancelled photo',
      body: 'The user cancelled the photo'
    } 
  });
  window.dispatchEvent(event)
}

window.skErrorUserMedia = () => {
  const event = new CustomEvent('errorModal', {
    detail: {
      title: 'Error',
      body: 'There was an error while trying to get the photo'
    } 
  });
  window.dispatchEvent(event)
}

window.skErrorUserQR = () => {
  const event = new CustomEvent('errorModal', {
    detail: {
      title: 'Error',
      body: 'There was an error while trying to get the QR'
    } 
  });
  window.dispatchEvent(event)
}

window.skErrorNFC = () => {
  const event = new CustomEvent('errorModal', {
    detail: {
      title: 'Error',
      body: 'There was an error while trying to get the NFC'
    } 
  });
  window.dispatchEvent(event)
}

window.skRecieveUserToken = token => {
  const event = new CustomEvent('jwtTokenRenewed', { detail: token });
  return window.dispatchEvent(event)
}

window.skErrorUserToken = () => {
  const event = new CustomEvent('errorModal', {
    detail: {
      title: 'Error',
      body: 'There was an error while trying to get the user token'
    } 
  });
  window.dispatchEvent(event)
}